<template>
	<v-layout 
		row 
		wrap 
		class="form-simulator"
		:class="{ 'quinti': isQinti || isLucky}">
		<v-flex xs12>
			<v-layout row wrap class="form-simulator-container">
				<v-flex xs12 class="form-simulator-input">
					<app-input
						label="Nombres"
						model="name"
						:value="form.name"
						@input="$emit('get-data', $event)"
					></app-input>
				</v-flex>
				<v-flex xs12 class="form-simulator-input">
					<app-input
						label="Apellidos"
						model="surName"
						:value="form.surName"
						@input="$emit('get-data', $event)"
					></app-input>
				</v-flex>
				<v-flex xs4 class="form-simulator-input">
					<app-select
						:items="documentTypes"
						item-text="name"
						item-value="id"
						model="flagTypePerson"
						return-object
						:value="form.flagTypePerson"
						border-total
						:title="documentSelected.name"
						@input="$emit('get-data', $event)"
					></app-select>
				</v-flex>
				<v-flex xs8 pl-2 text-xs-left class="form-simulator-input">
					<app-input
						label="Nro. de documento"
						model="documentNumber"
						:value="form.documentNumber"
						@input="$emit('get-data', $event)"
					></app-input>
					<span class="error--text caption" v-if="documentValidation">
						{{ validationMessage }}
					</span>
				</v-flex>
				<v-flex xs12 class="form-simulator-input">
					<app-select
						:items="items"
						item-text="name"
						item-value="id"
						label="Rubro"
						model="itemId"
						:value="form.itemId"
						@input="$emit('get-data', $event)"
					></app-select>
				</v-flex>
				<v-flex xs12 class="form-simulator-input" v-if="showPlan">
					<app-select
						:items="listPlans"
						item-text="name"
						item-value="code"
						label="Plan"
						model="typePlan"
						:value="form.typePlan"
						@input="$emit('get-data', $event)"
					></app-select>
				</v-flex>
				<v-flex xs12 text-xs-left class="form-simulator-input">
					<app-input
						label="Correo electrónico"
						model="email"
						type="email"
						:value="form.email"
						@input="$emit('get-data', $event)"
					></app-input>
					<span class="error--text caption" v-if="emailValidation">
						Ingresa un correo válido
					</span>
				</v-flex>
				<v-flex xs12 class="form-simulator-input">
					<app-input
						label="Contraseña"
						model="password"
						type="password"
						:value="form.password"
						@input="$emit('get-data', $event)"
					></app-input>
				</v-flex>
				<v-flex xs12 class="form-simulator-column form-simulator-input">
					<app-input
						:prefix="codePhone"
						label="Celular"
						model="phone"
						type="tel"
						:value="form.phone"
						@input="$emit('get-data', $event)"
					></app-input>
					<span class="error--text caption" v-if="phoneInvalid">
						{{ phoneMessage }}
					</span>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	import appInput from '@/components/home/form/app-input';
	import appSelect from '@/components/home/form/app-select';

	function showPlan() {
		if (this.$route.query.plan) {
			return Boolean(this.$route.query.plan);
		}
		return false;
	}

	function isQinti() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'QINTI';
		}
		return false;
	}

	function isLucky() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'LUCKY';
		}
		return false;
	}

	export default {
		name: 'form-simulator',
		components: {
			appInput,
			appSelect,
		},
		computed: {
			showPlan,
			isQinti,
			isLucky,
		},
		props: {
			codePhone: String,
			documentSelected: {
				default: () => {},
				type: Object,
			},
			documentTypes: {
				default: () => [],
				type: Array,
			},
			documentValidation: {
				default: true,
				type: Boolean,
			},
			emailValidation: {
				default: false,
				type: Boolean,
			},
			form: {
				default: () => {},
				type: Object,
			},
			items: {
				default: () => [],
				type: Array,
			},
			phoneInvalid: {
				default: true,
				type: Boolean,
			},
			phoneMessage: String,
			validated: {
				default: false,
				type: Boolean,
			},
			validationMessage: String,
			listPlans: {
				default: () => [],
				type: Array,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.form-simulator {
		padding: 5px 0px 137px;
		position: relative;
		z-index: 1;

		@media (min-width: 936px) {
			padding: 30px 0px 137px;
		}

		&-btn {
			border-radius: 4px !important;
			bottom: 0px;
			font-size: size(medium) !important;
			height: 29px !important;
			margin: auto;
			position: absolute;
			right: 0px;
			top: 0px;
			width: 75px !important;
		}

		&-column {
			position: relative;
			text-align: left;
		}

		&-input {
			@media (min-width: 936px) {
				margin-bottom: 8px;
			}
		}

		&-icon {
			position: absolute;
			right: 0px;
			top: 20px;
		}

		&-container {
			max-height: 505px;
			overflow: auto;
			padding: 0px 32px 30px;
			z-index: 1;
		}
	}

	.show-form {
		.form-simulator-container {
			max-height: calc(100vh - 207px);

			@media (min-width: 936px) {
				max-height: calc(100vh - 230px);
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/simulator/form-simulator.vue